export const dispatchActionLabels = {
  ver: "Ver y exportar",
  operar: "Registrar y entregar",
  anular: "Anular y ajustar",
  catalogo_insumos: "Administrar insumos",
  catalogo_destinos: "Administrar destinos",
};
const prefix = "supply_dispatch:";
export function initialAccessSelection(user) {
  const modules =
    user?.moduleAccessOverride ??
    user?.effectiveModules ??
    user?.baseModules ??
    [];
  return [
    ...modules,
    ...(modules.includes("supply_dispatch")
      ? (user?.supplyDispatchAccessOverride ?? ["heredar"]).map(
          (a) => prefix + a
        )
      : []),
  ];
}
export function accessOptions(catalog) {
  return catalog.flatMap((m) => [
    { label: `${m.label} (${m.key})`, value: m.key },
    ...(m.key === "supply_dispatch"
      ? Object.entries({
          heredar: "Heredar acciones del rol",
          ...dispatchActionLabels,
        }).map(([key, label]) => ({
          label: `↳ Despacho · ${label}`,
          value: prefix + key,
        }))
      : []),
  ]);
}
export function changeAccessSelection(previous, selected) {
  let next = selected || [];
  const changed = [...new Set([...previous, ...next])].filter(
    (k) => previous.includes(k) !== next.includes(k)
  );
  const dispatchChanged = changed.some(
    (k) => k === "supply_dispatch" || k.startsWith(prefix)
  );
  if (dispatchChanged) {
    if (
      previous.includes("supply_dispatch") &&
      !next.includes("supply_dispatch")
    )
      next = next.filter((k) => !k.startsWith(prefix));
    else if (
      changed.includes(prefix + "heredar") &&
      next.includes(prefix + "heredar") &&
      !changed.some(k => k.startsWith(prefix) && k !== prefix + "heredar" && next.includes(k))
    )
      next = [
        ...next.filter((k) => !k.startsWith(prefix)),
        prefix + "heredar",
        "supply_dispatch",
      ];
    else if (changed.includes(prefix + "ver") && !next.includes(prefix + "ver"))
      next = next.filter(
        (k) => !k.startsWith(prefix) && k !== "supply_dispatch"
      );
    else {
      next = next.filter((k) => k !== prefix + "heredar");
      if (
        next.some((k) => k.startsWith(prefix)) ||
        next.includes("supply_dispatch")
      )
        next.push("supply_dispatch", prefix + "ver");
    }
  }
  return { selection: [...new Set(next)], dispatchChanged };
}
export function accessPayload(selection, dispatchChanged) {
  return {
    moduleAccessOverride: selection.filter((k) => !k.startsWith(prefix)),
    ...(dispatchChanged
      ? {
          supplyDispatchAccessOverride: selection.includes(prefix + "heredar")
            ? null
            : selection
                .filter((k) => k.startsWith(prefix))
                .map((k) => k.slice(prefix.length)),
        }
      : {}),
  };
}
